module.exports = __webpack_public_path__ + "static/media/user_avatar.068614c0.svg";